import btConstants from "../../config/bt-constants";

export default class QuoteApi {
  static getHeaders = (checkSandbox = false) => {
    let headers: any = {
      Accept: "application/json",
      "Content-Type": "application/json",
    };

    if (checkSandbox && btConstants.isSandBoxMode) {
      headers["is-sandbox-mode"] = "1";
    }

    return headers;
  };
  static getHostCountries = async (productId: number) => {
    const response = await fetch(`${btConstants.BTapiUrl}/product/${productId}/host-countries`, {
      headers: this.getHeaders(),
    });
    return response.json();
  };

  static getDestinations = async (productId: number) => {
    const response = await fetch(`${btConstants.BTapiUrl}/products/${productId}/destination/groups`, {
      headers: this.getHeaders(),
    });
    return response.json();
  };

  static getNumberOfTrips = async (productId: number) => {
    const response = await fetch(`${btConstants.BTapiUrl}/products/${productId}/product-ranges`, {
      headers: this.getHeaders(),
    });
    return response.json();
  };

  static createQuote = async (data: any) => {
    const response = await fetch(`${btConstants.BTapiUrl}/quote`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: this.getHeaders(true),
    });
    return response.json();
  };

  static createOrder = async (data: any) => {
    const response = await fetch(`${btConstants.BTapiUrl}/orders/condensed`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: this.getHeaders(true),
    });
    return response.json();
  };

  static getPaymentIntent = async (order_number: string) => {
    const response = await fetch(`${btConstants.BTapiUrl}/orders/${order_number}/payment/intent`, {
      headers: this.getHeaders(true),
    });
    return response.json();
  };

  static paymentCard = async (order_number: string) => {
    const response = await fetch(`${btConstants.BTapiUrl}/orders/${order_number}/payment/charge`, {
      method: "POST",
      body: JSON.stringify({
        status: "Approved",
        generate_docs: true,
      }),
      headers: this.getHeaders(),
    });
    return response.json();
  };

  static paymentInvoice = async (order_number: string) => {
    const response = await fetch(`${btConstants.BTapiUrl}/orders/${order_number}/payment/invoice`, {
      method: "POST",
      body: JSON.stringify({
        status: "Approved",
        generate_docs: true,
      }),
      headers: this.getHeaders(true),
    });
    return response.json();
  };

  static getPartnerLogo = async (partnerId: string) => {
    const response = await fetch(
      `https://api.battleface.com/api/v1/site/1/affiliate/getaffiliatecobranding/${partnerId}`,
      {
        headers: this.getHeaders(false),
      }
    );
    return response.json();
  };
}
